export class Pagination {
    per_page = 10;
    current_page = 1;
    total = 1;
}
